import './PricingTable.css'; // Import the CSS file
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Layout from './Layout'; // Import the Layout component
import { useNavigate } from 'react-router-dom';
import { useAuth } from './StoreValue';
import { markStepComplete } from './StepGuard';
import { getAgentConfig, isPromotix } from '../utils/agentConfig';

const PricingInfo = () => {
    const { ContactGuid,agentIdVal,leadGuid, updateAgentId, updateContactGuid, updateLeadGuid } = useAuth();
    const variant = getAgentConfig(agentIdVal).pricing.variant;
    const isMWA   = variant === 'mw13601';   // agent 2774 — ACH only
    const isMWB   = variant === 'mw13602';   // agent 2773 — Cards + ACH
    const isEnsoraFlatVariant      = variant === 'ensora';
    const isEnsoraSurchargeVariant = variant === 'ensoraSurcharge';
    const isPromotixVariant        = variant === 'promotix';
    const isMW    = variant === 'standardMw';
    const isIntelecomVariant       = variant === 'intelecom';   // In-Telecom — standard table, In-Telecom label
    const navigate = useNavigate();
//const corporateInfo = '';
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');
        if (!leadGuid) {
            setErrorMessage('Session expired or lead data is missing. Please start over from the login page.');
            return;
        }
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
        const data = {
             leadguidVal: leadGuid,
             agentId: agentIdVal,
                Detail: {
                    TranType: "TranType",
                    TranAction: "TranAction",
                    Ip: 'Ip'
                },
                QueryRequest: {
                    Detail:{
                Client: "Client",
                ClientBranch: "Client",
                Active: "1"
                }
            }
        }
        try {
            const response = await axios.post(`${API_BASE_URL}/api/Auth/PricingManage`, data);
        if (response.data === 'OK') {
            markStepComplete('pricingInfo');
            // Promotix takes Pricing early (after Client) → next is Corporate; all others → Terms.
            navigate(isPromotix(agentIdVal) ? '/CorporateInfo' : '/TermsAndConditions');
        } else {
            setErrorMessage(typeof response.data === 'string' ? response.data : JSON.stringify(response.data));
        }
        } catch (error) {
            console.error('Error submitting form:', error);
            const serverMsg = error.response?.data?.message || error.response?.data || error.message;
            setErrorMessage(typeof serverMsg === 'string' ? serverMsg : 'An error occurred during submission.');
        }
    };

    return (
        <div className="signature-container">
        <Layout pageTitle="Pricing Information">
            <form onSubmit={handleSubmit}>
            <div className="error-message" style={{ color: 'red' }}>
                <span id="MainContent_errorMsg"></span>
                <p className="error"></p>
            </div>
            {isMWA ? (
                /* Branch A — agent 2774 (MW-13601): Cards + ACH + Keyed-in, Memberworks rates */
                <table id="MainContent_Table1">
                    <thead>
                        <tr>
                            <td></td>
                            <td className="t"><b>Memberworks</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b className="title">Cards &amp; digital wallets</b><br />
                                Invoices or quick requests paid using Visa, Mastercard, Discover, American Express, Apple Pay, PayPal, and Venmo
                            </td>
                            <td className="t">2.85%</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">ACH bank payments</b><br />
                                Invoices or quick requests paid using an electronic transfer that pulls money from a customer's bank account into yours
                            </td>
                            <td className="t">0.75% and $0.20 per item</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">Keyed-in cards</b><br />
                                Payments processed by manually entering a customer's card information. Not available with QuickBooks Money
                            </td>
                            <td className="t">3.25%</td>
                        </tr>
                    </tbody>
                </table>
            ) : isMWB ? (
                /* Branch B — agent 2773: Cards & digital wallets + ACH */
                <table id="MainContent_Table1">
                    <thead>
                        <tr>
                            <td></td>
                            <td className="t"><b>Memberworks</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b className="title">Cards &amp; digital wallets</b><br />
                                Invoices or quick requests paid using Visa, Mastercard, Discover, American Express, Apple Pay, PayPal, and Venmo
                            </td>
                            <td className="t">0.80% and $0.20 per item</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">ACH bank payments</b><br />
                                Invoices or quick requests paid using an electronic transfer that pulls money from a customer's bank account into yours
                            </td>
                            <td className="t">0.75% and $0.20 per item</td>
                        </tr>
                    </tbody>
                </table>
            ) : isEnsoraSurchargeVariant ? (
                /* Ensora Surcharge — credit cards pass-through, debit 1% */
                <table id="MainContent_Table1">
                    <thead>
                        <tr>
                            <td></td>
                            <td className="t-ensora"><b>TRX</b></td>
                            <td className="title"><b>Square</b></td>
                            <td className="title"><b>Ivy Pay</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b className="title">In person (Card Present)</b><br />
                                <span className="row-desc">Payments where the physical card is tapped, dipped, or swiped at the point of sale,
                                typically offering the lowest fees and strongest fraud protection.</span>
                            </td>
                            <td className="t-ensora">Credit Cards: No Interchange Fees<br />Signature Debit/Pre-paid Debit: 1%</td>
                            <td>2.6% + $0.15 per transaction</td>
                            <td>2.75%</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">Keyed / card-on-file</b><br />
                                <span className="row-desc">Transactions are card payments where details are manually entered or stored and charged
                                later without the card present, typically carrying higher fees and fraud risk than
                                in-person transactions.</span>
                            </td>
                            <td className="t-ensora">Credit Cards: No Interchange Fees<br />Signature Debit/Pre-paid Debit: 1%</td>
                            <td>3.5% + $0.15 per transaction</td>
                            <td>3.50%</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">ACH Payments</b><br />
                                <span className="row-desc">ACH transactions are electronic bank-to-bank payments that move funds directly between
                                accounts through the Automated Clearing House network.</span>
                            </td>
                            <td className="t-ensora">.50% per ACH Transaction</td>
                            <td>1% per ACH transaction<br />$1 minimum fee per transaction</td>
                            <td>1.2% per transaction</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">Patient Financing</b><br />
                                <span className="row-desc">Patient financing is a payment option that allows patients to spread the cost of medical
                                expenses over time through installment plans or credit, often with the provider paid upfront.</span>
                            </td>
                            <td className="t-ensora">6%<br />Minimum ticket $300<br />Maximum Ticket $15,000</td>
                            <td>6.0% + $0.30 per transaction for Installments</td>
                            <td>Not Offered</td>
                        </tr>
                    </tbody>
                </table>
            ) : isPromotixVariant ? (
                /* PromoTix — PromoTix Processing Pro vs Stripe vs PayPal (3-column comparison).
                   ACH is not offered for ticket sales, so there is no ACH row here. */
                <table id="MainContent_Table1">
                    <thead>
                        <tr>
                            <td></td>
                            <td className="t-promotix"><b>PromoTix Processing Pro</b></td>
                            <td className="title"><b>Stripe</b></td>
                            <td className="title"><b>PayPal</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b className="title">In person (Card Present/Gate Sales)</b><br />
                                <span className="row-desc">Payments where the physical card is tapped, dipped, or swiped at the point of sale,
                                typically offering the lowest fees and strongest fraud protection.</span>
                            </td>
                            <td className="t-promotix">2.50% + $0.05</td>
                            <td>2.7% + $0.05 per transaction<br />Tap to Pay adds $0.10 per authorization</td>
                            <td>2.29% + $0.09 per transaction</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">Online / Keyed / card-on-file</b><br />
                                <span className="row-desc">Transactions are card payments where details are manually entered or stored and charged
                                later without the card present, typically carrying higher fees and fraud risk than in-person transactions.</span>
                            </td>
                            <td className="t-promotix">2.75% + $0.25</td>
                            <td>2.9% + $0.30 per transaction</td>
                            <td>2.9% + $0.30 per transaction online<br />3.49% + $0.09 keyed-in</td>
                        </tr>
                    </tbody>
                </table>
            ) : isEnsoraFlatVariant ? (
                /* Ensora 2977 — Flat rate */
                <table id="MainContent_Table1">
                    <thead>
                        <tr>
                            <td></td>
                            <td className="t-ensora"><b>TRX</b></td>
                            <td className="title"><b>Square</b></td>
                            <td className="title"><b>Ivy Pay</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b className="title">In person (Card Present)</b><br />
                                <span className="row-desc">Payments where the physical card is tapped, dipped, or swiped at the point of sale,
                                typically offering the lowest fees and strongest fraud protection.</span>
                            </td>
                            <td className="t-ensora">2.99% + $0.30</td>
                            <td>2.6% + $0.15 per transaction</td>
                            <td>2.75%</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">Keyed / card-on-file</b><br />
                                <span className="row-desc">Transactions are card payments where details are manually entered or stored and charged
                                later without the card present, typically carrying higher fees and fraud risk than
                                in-person transactions.</span>
                            </td>
                            <td className="t-ensora">2.99% + $0.30</td>
                            <td>3.5% + $0.15 per transaction</td>
                            <td>3.50%</td>
                        </tr>
                        <tr>
                            <td>
                                <b className="title">Patient Financing</b><br />
                                <span className="row-desc">Patient financing is a payment option that allows patients to spread the cost of medical
                                expenses over time through installment plans or credit, often with the provider paid upfront.</span>
                            </td>
                            <td className="t-ensora">6%<br />Minimum ticket $300<br />Maximum Ticket $15,000</td>
                            <td>6.0% + $0.30 per transaction for Installments</td>
                            <td>Not Offered</td>
                        </tr>
                    </tbody>
                </table>
            ) : (
                /* Branch C — all other agents: full comparison table */
                <table id="MainContent_Table1">
                    <thead>
                        <tr>
                            <td></td>
                            <td className="t"><b>{isMW ? 'Memberworks' : isIntelecomVariant ? 'In-Telecom' : 'Rev.IO'}</b></td>
                            {!isMW && <td className="title"><b>QuickBooks</b></td>}
                            {!isMW && <td className="title"><b>Square</b></td>}
                            {!isMW && <td className="title"><b>Stripe</b></td>}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b className="title">Cards &amp; digital wallets</b><br />
                                Invoices or quick requests paid using Visa, Mastercard, Discover, American Express, Apple Pay, PayPal, and Venmo
                            </td>
                            <td className="t">2.75%</td>
                            {!isMW && <td>2.99%</td>}
                            {!isMW && <td>3.3%+30&#162;<br />No PayPal or Venmo</td>}
                            {!isMW && <td>2.9%+30&#162;*<br />No PayPal or Venmo</td>}
                        </tr>
                        {!isMW && (
                        <tr>
                            <td>
                                <b className="title">ACH bank payments</b><br />
                                Invoices or quick requests paid using an electronic transfer that pulls money from a customer's bank account into yours
                            </td>
                            <td className="t">.75%</td>
                            <td>1%</td>
                            <td>1%<br />$1 min</td>
                            <td>1.2%*</td>
                        </tr>
                        )}
                        <tr>
                            <td>
                                <b className="title">Keyed-in cards</b><br />
                                Payments processed by manually entering a customer's card information. Not available with QuickBooks Money
                            </td>
                            <td className="t">3.25%</td>
                            {!isMW && <td>3.5%</td>}
                            {!isMW && <td>3.5%+15&#162;</td>}
                            {!isMW && <td>3.4%+30&#162;</td>}
                        </tr>
                    </tbody>
                </table>
            )}
        <div className="d-flex justify-content-center mt-3">
    <button type="submit" className="btn btn-success px-5" style={{ width: '370px' }}>
        Next
    </button>
        </div>
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
                </form>
            </Layout>
            </div>
    );
};

export default PricingInfo;
